import React from "react";
import { Stack } from "@bookingcom/bui-react";
import { Breakdown } from "./Breakdown";
import { Installments, Atol, Disclaimers } from "./banners";
import {
  useUnifiedPriceBreakdownTicketTypeController,
  type UnifiedPriceBreakdownTicketTypeControllerProps
} from "./useUnifiedPriceBreakdown.TicketType.controller";

export type UnifiedPriceBreakdownTicketTypeProps = UnifiedPriceBreakdownTicketTypeControllerProps;

export function UnifiedPriceBreakdownTicketType(props: UnifiedPriceBreakdownTicketTypeProps) {
  const { addedItems, isHungaryDepartingRyanAir, disclaimers, unifiedPriceBreakdown, expandedByDefault } =
    useUnifiedPriceBreakdownTicketTypeController(props);

  if (!unifiedPriceBreakdown) {
    return null;
  }

  return (
    <Stack gap={4}>
      <Breakdown
        {...unifiedPriceBreakdown}
        addedItems={addedItems}
        isHungaryDepartingRyanAir={isHungaryDepartingRyanAir}
        expandedByDefault={expandedByDefault}
      />
      <Disclaimers disclaimers={disclaimers} />
      <Atol />
      <Installments />
    </Stack>
  );
}
